import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import HoldingsBg from '../../../assets/skeleton/HoldingsBg.png';
import BlockAccessPage from '../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../components/PageContent/PageContent';
import OwnershipTable from '../../../components/Table/OwnershipTable';
import Tabs from '../../../components/Tabs/Tabs';
// import InformativeText from '../../../constants/InformativeText';
import {PermissionEnum} from '../../../constants/permissionsEnum';
import TranslatedText from '../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../utils/SubscriptionHelper';
import EmployeeDetails from '../dataManagement/utils/userManagement/employeeDetails/EmployeeDetails';

import FacilityInfo from './facilityInfo/FacilityInfo';
// import OrgInfo from './orgInfo/OrgInfo';
import BusinessDetailsNew from './orgInfo/utils/BusinessDetailsNew';
import GeneralDisclosure from './orgInfo/utils/GeneralDisclosure';

const OrganizationFacility: React.FC = () => {
  const [searchParam] = useSearchParams();
  const [activeKey, setActiveKey] = useState<string>(
    searchParam.get('tab') ?? ''
  );

  const orgFac = [
    {
      id: 'General_Disclosure',
      name: <TranslatedText translationKey="General" />,
      component: (
        <GeneralDisclosure
          setActiveKey={setActiveKey}
          nextTabId="businessDetails"
        />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorFacilitiesGeneral
      )
    },
    {
      id: 'businessDetails',
      name: <TranslatedText translationKey="Business" />,
      component: <BusinessDetailsNew />,
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorFacilitiesBusiness
      )
    },
    {
      id: 'holding',
      name: (
        <TranslatedText
          translationKey="Holdings"
          // tooltip={InformativeText.Ownership.holdings}
        />
      ),
      component: shouldBlockModuleAccess(accessModule.externalStakeholders) ? (
        <BlockAccessPage backgroundImage={HoldingsBg} />
      ) : (
        <OwnershipTable />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorFacilitiesHoldings
      )
    },
    {
      id: 'FacilityInformation',
      name: <TranslatedText translationKey="Facilities" />,
      component: shouldBlockModuleAccess(accessModule.facility) ? (
        <BlockAccessPage />
      ) : (
        <FacilityInfo />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorFacilitiesFacility
      )
    },
    {
      id: 'empData',
      name: <TranslatedText translationKey="Employees" />,
      component: shouldBlockModuleAccess(accessModule.employees) ? (
        <BlockAccessPage />
      ) : (
        <EmployeeDetails />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorFacilitiesEmployee
      )
    }
  ].filter((item) => !item.hidden);

  return (
    <PageContent fullscreen={false}>
      <Tabs
        array={orgFac}
        noPadding
        fullWidth
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
    </PageContent>
  );
};

export default OrganizationFacility;
